import { GetterTree } from "vuex"
import { BookingResource, BookingsState } from "~/store/bookings/bookings.types"
import { RootState } from "~/store/store.types"
import { getResource } from "~/utils/store"

const getters: GetterTree<BookingsState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<BookingResource>(state, id, rootGetters, included)
  }
}

export default getters
